import { type TierFeature } from '/@/common/tiers'
import { createModal } from '/@/core/elements/modal'
import { type DesignerTier } from '/@/data/designer/types'
import { defineAsyncComponent } from 'vue'
import { stellaModal } from '/@/stella/StellaModal'

export interface TierUpgradeModalData {
  upgradeType?: DesignerTier
  tierFeature?: TierFeature | null
  source: string
  strict?: boolean
  trackingProps?: Record<string, unknown>
  onBack?: () => void
  onSubmit?: () => void
}

export interface LegacyTierUpgradeModalData {
  upgradeType?: DesignerTier
  tierFeature: TierFeature
  source: string
  trackingProps?: Record<string, unknown>
  onBack?: () => void
}

const { api, component } = createModal<TierUpgradeModalData>(
  'TierUpgradeModal',
  () => import('./TierUpgradeModal.vue'),
)

export function useLegacyTierUpgradeModal() {
  function openLegacyTierUpgradeModal(data: LegacyTierUpgradeModalData) {
    stellaModal.open({
      content: defineAsyncComponent(
        () =>
          import(
            '/@/common/modals/TierUpgradeModal/LegacyTierUpgradeModalContent.vue'
          ),
      ),
      data,
    })
  }

  return {
    openLegacyTierUpgradeModal,
  }
}

export const useTierUpgradeModal = api
export default component
